import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import moment from 'moment'
import Layout from '../components/Layout'
import CalendarPageTemplate from '../components/CalendarPageTemplate'

const prepareEvents = (frontmatter)=>{
  const items = frontmatter.events
  return Array.isArray(items) && items.map((item,index)=>{
     const start_date =  moment(item.start_date).format('MM/DD/YYYY');
     const end_date =  moment(item.end_date).format('MM/DD/YYYY');
     const text = item.text;
     return ({ id:index+1,start_date,end_date,text})
  }

  )
}


const Component = ({ data }) => {
  const results = data.markdownRemark.frontmatter;
  const events= prepareEvents(results)
  //console.log(events)
  return (
    <Layout>
      <CalendarPageTemplate
        events={events}
      />
    </Layout>
  )
}

Component.propTypes = {
  data: PropTypes.shape({
    markdownRemark: {
      frontmatter:PropTypes.shape({
        events:PropTypes.array
      })
    },
  }),
}

export default Component

export const PageQuery = graphql`
  query {
  markdownRemark(frontmatter:{
    templateKey:{eq:"calendar-page"}
  }){
    frontmatter{
      events{
        text
        start_date
        end_date
      }
    }
  }
}
`;
